import { render, staticRenderFns } from "./OnData.vue?vue&type=template&id=70e8a8ef&scoped=true&"
import script from "./OnData.vue?vue&type=script&lang=js&"
export * from "./OnData.vue?vue&type=script&lang=js&"
import style0 from "./OnData.vue?vue&type=style&index=0&id=70e8a8ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e8a8ef",
  null
  
)

export default component.exports